module.exports = __webpack_public_path__ + "img/my favorites.bbcb2220.png";